var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-preferences-campaigns__container" },
    [
      _c("preloader", { attrs: { display: _vm.isLoading } }),
      _vm._v(" "),
      _c(
        "h2",
        {
          staticClass:
            "marketing-preferences-campaigns__title typographies-heading-h2"
        },
        [_vm._v("\n        " + _vm._s(_vm.labels.maintTitle) + "\n    ")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "marketing-preferences-campaigns__default-subscription"
        },
        [
          _c(
            "h3",
            {
              staticClass:
                "marketing-preferences-campaigns__default-subscription-title typographies-heading-h3"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labels.defaultConsent.title) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassSwitch", {
            staticClass:
              "marketing-preferences-campaigns__default-subscription-switch",
            attrs: {
              label: _vm.labels.defaultConsent.switch,
              orientation: "left"
            },
            on: {
              change: function($event) {
                return _vm.updateConsent(false)
              }
            },
            model: {
              value: _vm.defaultConsent,
              callback: function($$v) {
                _vm.defaultConsent = $$v
              },
              expression: "defaultConsent"
            }
          }),
          _vm._v(" "),
          _c("p", {
            staticClass:
              "marketing-preferences-campaigns__default-subscription-informations typographies-paragraph-medium-regular",
            domProps: {
              innerHTML: _vm._s(_vm.labels.defaultConsent.informations)
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "marketing-preferences-campaigns__confirm-subscription"
        },
        [
          _c(
            "h3",
            {
              staticClass:
                "marketing-preferences-campaigns__confirm-subscription-title typographies-heading-h3"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labels.doubleOptin.title) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("CompassSwitch", {
            staticClass:
              "marketing-preferences-campaigns__confirm-subscription-switch",
            attrs: {
              label: _vm.labels.doubleOptin.switch,
              orientation: "left"
            },
            on: {
              change: function($event) {
                return _vm.updateConsent(false)
              }
            },
            model: {
              value: _vm.doubleOptin.enable,
              callback: function($$v) {
                _vm.$set(_vm.doubleOptin, "enable", $$v)
              },
              expression: "doubleOptin.enable"
            }
          }),
          _vm._v(" "),
          _c(
            "p",
            {
              staticClass:
                "marketing-preferences-campaigns__confirm-subscription-informations typographies-paragraph-medium-regular"
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.labels.doubleOptin.informations) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _vm.doubleOptin.enable
            ? _c(
                "div",
                {
                  staticClass:
                    "marketing-preferences-campaigns__confirm-subscription-more"
                },
                [
                  _c("CompassAlert", {
                    staticClass:
                      "marketing-preferences-campaigns__confirm-subscription-more-alert",
                    attrs: {
                      showClose: false,
                      description: _vm.labels.doubleOptin.alert
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "marketing-preferences-campaigns__confirm-subscription-more-form"
                    },
                    [
                      _c(
                        "CompassFormItem",
                        { attrs: { label: _vm.labels.doubleOptin.form.email } },
                        [
                          _c("CompassInput", {
                            model: {
                              value: _vm.doubleOptin.confirmEmail.sender.email,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.doubleOptin.confirmEmail.sender,
                                  "email",
                                  $$v
                                )
                              },
                              expression:
                                "doubleOptin.confirmEmail.sender.email"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        {
                          attrs: { label: _vm.labels.doubleOptin.form.sender }
                        },
                        [
                          _c("CompassInput", {
                            model: {
                              value: _vm.doubleOptin.confirmEmail.sender.name,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.doubleOptin.confirmEmail.sender,
                                  "name",
                                  $$v
                                )
                              },
                              expression: "doubleOptin.confirmEmail.sender.name"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        {
                          attrs: { label: _vm.labels.doubleOptin.form.object }
                        },
                        [
                          _c("CompassInput", {
                            model: {
                              value: _vm.doubleOptin.confirmEmail.subject,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.doubleOptin.confirmEmail,
                                  "subject",
                                  $$v
                                )
                              },
                              expression: "doubleOptin.confirmEmail.subject"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        { attrs: { label: _vm.labels.doubleOptin.form.label } },
                        [
                          _c("RichText", {
                            staticClass: "custom-richtext",
                            attrs: { options: _vm.optionsRichText },
                            model: {
                              value: _vm.doubleOptin.confirmEmail.body,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.doubleOptin.confirmEmail,
                                  "body",
                                  $$v
                                )
                              },
                              expression: "doubleOptin.confirmEmail.body"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "CompassFormItem",
                        {
                          attrs: { label: _vm.labels.doubleOptin.form.button }
                        },
                        [
                          _c("CompassInput", {
                            model: {
                              value: _vm.doubleOptin.confirmEmail.button.label,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.doubleOptin.confirmEmail.button,
                                  "label",
                                  $$v
                                )
                              },
                              expression:
                                "doubleOptin.confirmEmail.button.label"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "marketing-preferences-campaigns__confirm-subscription-more-form-buttons"
                        },
                        [
                          _c("CompassButton", {
                            attrs: { label: _vm.labels.doubleOptin.save },
                            on: {
                              click: function($event) {
                                return _vm.updateConsent(true)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }